<template>
  <div>
    <!-- 篩選功能 -->
    <div class="card filter-card">
      <div class="card-body">
        <div class="row">
          <div v-if="!filterVisible" class="filter-toggle-icon " @click="toggleFilter">
            <i class="fa fa-search"></i>
          </div>
          <div v-else>
            <button class="btn btn-toggle" @click="toggleFilter"><i class="fa fa-times"></i></button>
            <div class="row d-flex align-items-center">
            <div class="row col-md-10 input-row">
              <div class="col-md-4">
                <label for="driver-name">Driver Name</label>
                <input type="text" id="driver-name" class="form-control input-lg" v-model="filters.driverName" placeholder="Driver Name" />
              </div>
              <div class="col-md-4">
                <label for="driver-id">Driver ID</label>
                <input type="text" id="driver-id" class="form-control input-lg" v-model="filters.driverID" placeholder="Driver ID" />
              </div>
              <div class="col-md-4">
                <label for="plate-number">Plate Number</label>
                <input type="text" id="plate-number" class="form-control input-lg" v-model="filters.plateNumber" placeholder="Plate Number" />
              </div>
              <!-- <div class="col-md-4">
                <label for="plate-number">Type</label>
                <select id="payment-method" class="form-control" v-model="filters.paymentMethod">
                      <option value="">All</option>
                      <option value="Bank transfer">Bank transfer</option>
                      <option value="Cash">Cash</option>
                </select>
              </div> -->
              <div class="col-md-4">
                <label for="from-date">From</label>
                <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.fromDate" :enable-time-picker="false" data-language="en" placeholder="Select date" />
              </div>
              <div class="col-md-4">
                <label for="to-date">To</label>
                <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.toDate" :enable-time-picker="false" data-language="en" placeholder="Select date" />
              </div>
            </div>
              <div class="col-md-2 mt-5">
                <button class="btn btn-reset" @click="resetFilters">Reset</button>
                <button class="btn btn-search mt-1" @click="search">Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 切換 -->
    <ul class="nav nav-tabs">
      <li v-for="tab in visibleTabs" :key="tab.value" class="nav-item">
        <a class="nav-link" :class="{ active: filters.paymentMethod === tab.value }" @click="setActiveTab(tab.value)">{{ tab.label }}</a>
      </li>
    </ul>

    <!-- 列表 -->
    <div class="card" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table" >
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('created_at')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'created_at'}">
                  <span>Date &nbsp;</span>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col">Driver ID</th>
                <th scope="col">Driver name</th>
                <th scope="col">Plate</th>
                <th 
                  @click="sortTable('transactions')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'transactions'}">
                  <span>Transactions &nbsp;</span>
                  <i v-if="filters.sort_by === 'transactions' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'transactions' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('settlement_ref')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'settlement_ref'}">
                  <span>Settlement ref &nbsp;</span>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('face_value')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'face_value'}">
                  <span>Face value &nbsp;</span>
                  <i v-if="filters.sort_by === 'face_value' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'face_value' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'paid'}">
                  <span>Paid &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col">Actions</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index" >
                <td @click="openEditModal(item.id)" style="cursor: pointer;">{{ item.created_at }}</td>
                <td>{{ item.drivers[0].driver_id }}</td>
                <td>{{ item.drivers[0].first_name }}&nbsp;{{ item.drivers[0].middle_name }}&nbsp;{{ item.drivers[0].last_name }}</td>
                <td>{{ item.drivers[0].license.plate_number }}</td>
                <td>{{ item.transactions }}</td>
                <td>{{ item.settlement_ref }}</td>
                <td>{{ formatCurrency(item.face_value) }}</td>
                <td>{{ formatCurrency(item.paid )}}</td>
                <td>
                  <div class="d-flex">
                    <button class="btn-edit" @click="openEditModal(item.id)"><img src="@/assets/images/admin/cashpayments/edit.png" alt="Edit" style="width: 25px; height: 25px;" /></button>
                    <UndoButton v-if="filters.paymentMethod != 'Withdraw' && filters.paymentMethod != 'Card'" :id="item.id" />
                  </div>
                </td>
                <td v-if="item.status === 1" class="text-settled">Settled</td>
                <td v-else class="text-draft">Draft</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper" v-if="paginatedData.length > 0">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" />
            </button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>Page <input type="number" v-model.number="currentPage" @change="changePage(currentPage)" /> of {{ totalPages }}</span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" />
            </button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
            <button class="btn btn-selectall" @click="remitCSV">
              <img  src="@/assets/images/admin/cashpayments/download.png" alt="Download" style="width: 25px; height: 25px;" />
            </button>
          </div>
          <div class="total-count">
            Displaying transactions {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>
  </div>
  <EditCashPayment ref="editModalRef" />
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { usePaymentListStore } from '@/store/admin/cashPayment/paymentList';
import { usePermissionStore } from '@/store/admin/permission';
import EditCashPayment from './editCashPayment.vue';
import UndoButton from './undoButton.vue';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { onBeforeRouteLeave } from 'vue-router';  

const paymentListStore = usePaymentListStore();
const permissionStore = usePermissionStore();
const permissionsInitialized = ref(false);

const paginatedData = computed(() => paymentListStore.paginatedData);
const totalPages = computed(() => paymentListStore.totalPages);
const totalEntries = computed(() => paymentListStore.totalEntries);
const currentPage = computed(() => paymentListStore.currentPage);
const itemsPerPage = computed(() => paymentListStore.itemsPerPage);

const editModalRef = ref(null);
const openEditModal = (id) => {
  editModalRef.value.showModal(id);
}

const filterVisible = ref(false);
const paymentTabs = [
  { label: 'Cash', value: 'Cash', permission: 'Transfers-Cash' },
  { label: 'Bank transfer', value: 'Bank transfer', permission: 'Transfers-Bank transfer' },
  { label: 'Withdraw', value: 'Withdraw', permission: 'Transfers-Withdraw' },
  { label: 'Card', value: 'Card', permission: 'Transfers-Card' }
];

const hasTransferLevelPermissions = computed(() => {
  return permissionStore.permissions.some(permission => permission.name.startsWith('Transfers-'));
});

const visibleTabs = computed(() => {
  // 權限尚未初始化時先顯示全部，避免畫面先全隱藏
  if (!permissionsInitialized.value) {
    return paymentTabs;
  }

  // 新版權限：使用 Transfers-* 子權限
  if (hasTransferLevelPermissions.value) {
    return paymentTabs.filter(tab => permissionStore.hasPermission(tab.permission));
  }

  // 舊版權限：只有父層 Payments & Transfers
  return permissionStore.hasPermission('Payments & Transfers') ? paymentTabs : [];
});

const getDefaultPaymentMethod = () => {
  return visibleTabs.value[0]?.value || '';
};

const filters = ref({
  driverName: '',
  driverID: '',
  plateNumber: '',
  fromDate: '',
  toDate: '',
  paymentMethod: getDefaultPaymentMethod(),
  sort_by:'created_at',
  order:'desc'
});


// 表格排序處理邏輯
const sortTable = (field) => {
  if (filters.value.sort_by === field) {
    filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc';
  } else {
    filters.value.sort_by = field;
    filters.value.order = 'desc';
  }
  search();  // 重新調用API進行查詢
};

//格式化日期
const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const formatCurrency = (value) => {
    const absValue = Math.abs(value).toFixed(2); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

//切換篩選區塊顯示
const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const setActiveTab = async (type) => {
  if (!visibleTabs.value.some(tab => tab.value === type)) {
    return;
  }
  filters.value.paymentMethod = type;
  search();
};

const ensureValidActiveTab = () => {
  if (!visibleTabs.value.length) {
    return;
  }
  const hasActiveTab = visibleTabs.value.some(tab => tab.value === filters.value.paymentMethod);
  if (!hasActiveTab) {
    filters.value.paymentMethod = getDefaultPaymentMethod();
  }
};

watch(visibleTabs, () => {
  ensureValidActiveTab();
});

onBeforeRouteLeave(() => {
  filters.value = {
    driverName: '',
    driverID: '',
    plateNumber: '',
    fromDate: '',
    toDate: '',
    paymentMethod: getDefaultPaymentMethod(),
    sort_by:'created_at',
    order:'desc'
  };
  paymentListStore.filters = filters.value;
});

const resetFilters = () => {
  filters.value = {
    driverName: '',
    driverID: '',
    plateNumber: '',
    fromDate: '',
    toDate: '',
    paymentMethod: filters.value.paymentMethod,
    sort_by:'created_at',
    order:'desc'
  };
  search();
};



//篩選查詢
const search = async () => {
  paymentListStore.filters = filters.value;
  paymentListStore.currentPage = 1;
  await paymentListStore.fetchPayments();
};

//分頁換頁
const changePage =  (page) => {
   paymentListStore.changePage(page);
};

const remitCSV = async() =>{
  await paymentListStore.remitCSV();
};

onMounted(async () => {
  const admin = JSON.parse(localStorage.getItem('Admin'));
  if (admin?.role_id) {
    await permissionStore.fetchPermissions(admin.role_id);
  }
  permissionsInitialized.value = true;

  ensureValidActiveTab();
  currentPage.value = 1;

  paymentListStore.changePage(1); // 重置分页到第一页
  await paymentListStore.fetchPayments();
});
</script>


  <style scoped>
  .card {
    border-radius: 10px;
    border-radius: 0px 10px 10px 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 0px;
    position: relative;
  }
  

  .nav-tabs .nav-item {
    margin-bottom: -1px;
  }

  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-radius: 10px 10px 0px 0px;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .nav-tabs .nav-link.active {
    border-color: #ddd #ddd #fff;
    background-color: #fff;
    color: #000;
  }



  .no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

  
  .filter-card {
    margin-bottom: 20px;
  }
  
  .filter-toggle-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 24px;
    color: #666;
    cursor: pointer;
  }

  .btn-reset {
    /* BTN_B */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Indigo */
    border: 2px solid #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .btn-search{
    /* BTN_A_V2 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    background: #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

  }

   
  .btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }
  
  .btn-green {
    background: #00c962;
    color: #fff;
    border: none;
    margin-top: 25px;
    height: 45px;
  }
  
  .btn-green:hover {
    background: #00b452;
  }
  
  .btn-toggle {
    background: none;
    border: none;
    color: #666;
    font-size: 24px;
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 10px;
  }

  .btn-edit {
    color: #8476f5;
    background: transparent;     
    border: none;                
    padding: 0.375rem 0.75rem;      
    font-size: 1rem;            
    border-radius: 0.25rem;        
    cursor: pointer;
    display: inline-flex;          
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease-in-out;
    width: 40px;
    height: 40px;
  }

  .btn-edit:hover {
    border: 1px solid #c3c3c3;
  }
  
  .input-lg {
    height: calc(2.25rem + 10px);
  }
  
  .input-row {
    margin-top: 10px;
  }
  
  .input-group {
    margin-bottom: 15px;
  }
  
  .btn-group {
    display: flex;
    justify-content: flex-end;
  }
  
  .table-responsive {
    margin-top: 20px;
  }
  
  .table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
  }
  
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }
  
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
  }

  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 135px !important;
  }
  
  .table-hover tbody tr:hover {
    color: #495057;
    background-color: rgba(0, 0, 0, 0.075);
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  
  .pagination-container {
    display: flex;
    align-items: center;
  }
  
  .pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
  }
  
  .pagination-container span {
    margin: 0 10px;
  }
  
  .pagination-container input {
    width: 50px;
    text-align: center;
  }
  
  .total-count {
    font-size: 16px;
    color: #666;
  }

  .table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

  .text-settled{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #00C962;
  }

  .text-draft{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #ff5858;
  }


  @media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
  
  @media (max-width: 768px) {
    .card-body {
      padding: 10px;
    }
  
    .filter-toggle-icon {
      justify-content: end;
      font-size: 20px;
    }

    .btn-toggle{
      display: flex;
      justify-content: end;
      font-size: 20px;
    }
  
    .btn-reset, .btn-green, .btn-toggle, .btn-search {
      width: 100%;
      margin-top: 10px;
    }
  
    .btn-reset, .btn-search {
      margin-right: 0;
    }
  
    .text-end {
      text-align: center !important;
    }
  }
  </style>
  